/* ==========================================================================
   SearcherFlight > Client > Discount > Panel > Resident > Modal
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addData, addStyle } = require('@bluekiri/alexandria/helpers/dataHelpers');

const { fromEvent, of } = require('rxjs');
const { take, mergeAll } = require('rxjs/operators');

const Modal = require('@bluekiri/alexandria-contrib-components/components/modal-rxjs/client/js');
const ModalTemplate = require('@bluekiri/alexandria-contrib-components/components/modal-rxjs/template');

const configuration = require('../../../../config');

const renderContent = (content, context) =>
    html(content.map(item => html(`<p class='searcher__information'>${ViewHelpers(context).markdown(item)}</p>`)));

const renderInformations = (informations, context) =>
    html(
        informations.map(({ content, title }) => {
            return html(`
                <p class='searcher__title'>${title}</p>
                ${renderContent(content, context)}
            `);
        })
    );

/* Create */
function createModal(instance) {
    /* Data */
    const { context } = instance.config;
    const {
        resident: { label, informations }
    } = instance.config;

    /* Template */
    const template = ModalTemplate(
        addStyle(
            addData(
                {
                    title: label,
                    body: renderInformations(informations, context)
                },
                {
                    type: configuration().type.discount
                }
            ),
            [configuration().css.flight]
        ),
        context
    );

    /* Node */
    const node = toNode(template)[0];

    /* Return */
    return node;
}

/* Add */
function addModal(instance) {
    const panel = instance;

    /* Node */
    const node = createModal(instance);

    /* Add to DOM */
    document.body.appendChild(node);

    /* Reference */
    panel.discountModal = Modal(`[data-component='ModalRxjs'][data-type='${configuration().type.discount}']`);

    const { click$, keyup$ } = instance.discountModal.events;

    /* Delegate */
    fromEvent(node, 'transitionend')
        .pipe(take(1))
        .subscribe(() => {
            /* Subscriptions */
            panel.subscriptions = {
                ...instance.subscriptions,
                closeResidentModal: of(keyup$, click$)
                    .pipe(mergeAll())
                    .subscribe(() => {
                        /* Remove */
                        removeModal(instance);
                    })
            };
        });

    /* Visible */
    setTimeout(() => instance.discountModal.actions.display(), 50);
}

/* Remove */
function removeModal(instance) {
    const panel = instance;

    /* Subscriptions */
    instance.subscriptions.closeResidentModal.unsubscribe();
    delete panel.subscriptions.closeResidentModal;

    /* Reference */
    instance.discountModal.actions.hide();
    instance.discountModal.actions.destroy();
    delete panel.discountModal;
}

/* Exports */
module.exports = {
    addModal
};
